import { api } from ".";
import { ServiceContractBase } from "../types/serviceContractBase";
import { ServiceUpdate } from "../types/serviceUpdate";

export default class ServiceApi {
  static async login(id: number, email: string) {
    const res = await api.post("/serviceContract/login", {
      id: id,
      email: email,
    });
    return res.data;
  }
  static async getContract(): Promise<ServiceContractBase> {
    const res = await api.get("/serviceContract/getContract");
    return res.data;
  }

  static async getUpdatedService(id: number): Promise<ServiceUpdate> {
    const res = await api.get(`/serviceContract/getUpdatedService?id=${id}`);
    return res.data;
  }

  static async updateService(
    price: string,
    serviceId: number,
    issRate: string,
    pisRate: string,
    cofinsRate: string
  ): Promise<ServiceContractBase> {
    const res = await api.post("/serviceContract/updateService", {
      serviceUpdate: {
        price: price,
        issRate: issRate,
        pisRate: pisRate,
        cofinsRate: cofinsRate,
      },
      serviceId: serviceId,
    });
    return res.data;
  }

  static async updateContract(
    responsibleName: string,
    responsibleEmail: string,
    witnessName: string,
    witnessEmail: string
  ): Promise<ServiceContractBase> {
    const res = await api.post("/serviceContract/updateContract", {
      serviceContractUpdate: {
        responsibleName: responsibleName,
        responsibleEmail: responsibleEmail,
        witnessEmail: witnessEmail,
        witnessName: witnessName,
      },
    });
    return res.data;
  }

  static async partialUpdateContract(
    responsibleName: string,
    responsibleEmail: string,
    witnessName: string,
    witnessEmail: string
  ): Promise<ServiceContractBase> {
    const res = await api.post("/serviceContract/partialUpdateContract", {
      serviceContractUpdate: {
        responsibleName: responsibleName,
        responsibleEmail: responsibleEmail,
        witnessEmail: witnessEmail,
        witnessName: witnessName,
      },
    });
    return res.data;
  }

  static async setKeepConditions(keepConditions: boolean) {
    await api.post("/serviceContract/setKeepConditions", {
      keepConditions: keepConditions,
    });
  }

  static async setProblem(issueText: string) {
    await api.post("/serviceContract/problem", {
      issueText: issueText,
    });
  }
}
